import React from 'react'

type DataItemProps = {
    name: string
    className: string
    children?: React.ReactNode
}

const DataItem: React.FC<DataItemProps> = ({ name, children, className }) => (
    <div className={className}>
        <h6>{name}</h6>
        <div className="body1 light">{children}</div>
    </div>
)

export default DataItem
